import { ApiBase } from '../api-base'

export class UserServices extends ApiBase {
  constructor() {
    super({
      resource: '/api/v1/users',
      name: 'user',
      successPath: '/'
    })
  }

  index({ q, page = '', byRole = null, status = null }) {
    const params = {}
    if (q) params.q = q
    if (status) params.active = status
    if (page) params.page = page
    if (byRole) params.role = byRole

    return this.api.get(`${this.resource}?` + new URLSearchParams(params).toString())
  }

  signIn({ body }) {
    return this.api.post('/users/sign_in', body)
  }

  currentUser() {
    return this.api.get('/users/current')
  }

  signOut() {
    return this.api.delete('/users/sign_out')
  }

  getOffices() {
    return this.api
      .get('/api/v1/accounts/offices?own=true')
      .then(response => response.data.offices)
  }

  /**
   * Verifica acceso para documento y oficina.
   * @param {string} document - RUT o patente
   * @param {string|null} officeId - ID de dependencia
   * @param {string|null} event - query|entry|exit
   * @param {string|null} observations - texto de observaciones
   * @param {object} meta - meta info adicional { pistol?: boolean }
   */
  verifyAccess(document, officeId = null, event = null, observations = null, meta = {}) {
    const params = new URLSearchParams()
    if (document) params.append('documento', document)
    if (officeId) params.append('office_id', officeId)
    if (event) params.append('event', event)
    if (observations) params.append('observations', observations)
    if (typeof meta.pistol === 'boolean') params.append('pistol', meta.pistol ? 'true' : 'false')

    return this.api
      .get(`/api/v1/access_control/check_access?${params.toString()}`)
      .then(response => response.data)
      .catch(error => {
        if (error.response?.status === 404) {
          return error.response.data
        }
        throw error
      })
  }
}